import { render, staticRenderFns } from "./FrameSubmenu.vue?vue&type=template&id=4cad0b90&scoped=true&"
import script from "./FrameSubmenu.vue?vue&type=script&lang=js&"
export * from "./FrameSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cad0b90",
  null
  
)

export default component.exports